import { takeLatest, put, call, select } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import { auditLogsAPI } from '../../api/config';
import {
  fetchAuditLogsSuccess,
  fetchAuditLogsFailure,
  fetchAuditLogSuccess,
  fetchAuditLogFailure,
  fetchAuditSummarySuccess,
  fetchAuditSummaryFailure,
} from '../actions/auditLogActions';

// Get current state
const getAuditState = (state) => state.auditLogs;

function* fetchAuditLogs(action) {
  try {
    const { filters, pagination } = yield select(getAuditState);
    const requestParams = {
      ...filters,
      ...pagination,
      ...action.payload, // Override with any params passed in the action
    };

    // Filter out empty values
    const cleanParams = Object.fromEntries(
      Object.entries(requestParams).filter(([_, value]) =>
        value !== null && value !== undefined && value !== ''
      )
    );
    
    const response = yield call(auditLogsAPI.fetchAuditLogs, cleanParams);
    yield put(fetchAuditLogsSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch audit logs';
    yield put(fetchAuditLogsFailure(errorMessage));
    message.error(errorMessage);
  }
}

function* fetchAuditLog(action) {
  try {
    const { id } = action.payload;
    const response = yield call(auditLogsAPI.getAuditLog, id);
    yield put(fetchAuditLogSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch audit log';
    yield put(fetchAuditLogFailure(errorMessage));
    message.error(errorMessage);
  }
}

function* fetchAuditSummary(action) {
  try {
    const requestParams = action.payload || {};
    // Filter out empty values
    const cleanParams = Object.fromEntries(
      Object.entries(requestParams).filter(([_, value]) =>
        value !== null && value !== undefined && value !== ''
      )
    );
    
    const response = yield call(auditLogsAPI.getAuditSummary, cleanParams);
    yield put(fetchAuditSummarySuccess(response.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch audit summary';
    yield put(fetchAuditSummaryFailure(errorMessage));
    message.error(errorMessage);
  }
}

export function* auditLogSaga() {
  yield takeLatest(types.FETCH_AUDIT_LOGS_REQUEST, fetchAuditLogs);
  yield takeLatest(types.FETCH_AUDIT_LOG_REQUEST, fetchAuditLog);
  yield takeLatest(types.FETCH_AUDIT_SUMMARY_REQUEST, fetchAuditSummary);
}
